import React, { useState, useEffect } from "react";
import { GetBlogData } from "../../../Services/UserService/User";
import Content from "../../../components/Contents/Content";
import Loader from "../../../../Utils/Loader";
import { Link } from "react-router-dom";
import { fDate } from "../../../../Utils/Date_formate";

const Blogs = () => {


  const [blogData, setBlogData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const GetBlogDataApi = async () => {
    try {
      const response = await GetBlogData();
      if (response.status) {
        setBlogData(response.data || []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetBlogDataApi();
  }, []);

  return (
    <Content
      Page_title="Blogs"
      button_status={false}
      backbutton_status={true}
    >
      {isLoading ? (
        <Loader />
      ) : blogData.length === 0 ? (

        <div className="text-center mt-4">
          <img src="/assets/images/nodata.png" alt="No Records Found" className="w-25" />
        </div>

      ) : (
        <div className="row">
          {blogData.map((blog, index) => (
            <div className={`col-md-4 mb-3 ${blogData.length === 1 ? "mx-auto" : ""
              }`} key={index}>
              <div className="card h-100">
                <img src={blog.image} alt="blog" style={styles.image} />
                <div style={styles.content}>
                  <small style={styles.date}>{fDate(blog.created_at)}</small>
                  <h3 className="text-white" style={styles.title}>{blog.title}</h3>
                  <p
                    className="blog-para text-white"
                    dangerouslySetInnerHTML={{ __html: blog.description }}
                  />
                  <Link
                    to="/user/blogdetail"
                    state={{ blogData: blog }}
                    className="btn btn-primary"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Content>
  );
};

const styles = {
  image: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
  },
  content: {
    padding: "15px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  description: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  date: {
    fontSize: "12px",
    color: "#888",
  },
};

export default Blogs;
